import React, {
    useContext
} from 'react';
import {
    useNavigate, useParams
} from 'react-router-dom';
import {
    Button
} from './ui/button';
import {
    BuildingIcon, ChevronDownIcon, LucideSettings
} from 'lucide-react';
import {
    DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem
} from './ui/dropdown-menu';
import {
    Context
} from 'shared/context/GlobalState';
import {
    ScrollArea
} from './ui/scroll-area';

export default function DashboardSubHeader() {
    // Context
    const {
        organizations
    } = useContext(Context) as any;
    const navigate = useNavigate();
    const {
        oragID
    } = useParams();

    // Getters
    const userOrganizationCount = organizations.length;
    const hasEnoughOrganizations = userOrganizationCount > 0;
    const organizationTitle = organizations.find(item => item._id === oragID)?.name ?? 'No Organization Selected';

    // Actions
    const handleOrganizationChange = (org) => {
        navigate(`/organizations/${org._id}`);
    };

    const handleSettingsClick = () => {
        navigate(`/organizations/${oragID}/settings`);
    };

    const handleViewAllOrganizations = () => {
        navigate('/organizations');
    };

    return (
        <DropdownMenu>
            {/* Active Organization */}
            <div className='flex items-center'>
                <DropdownMenuTrigger asChild disabled={!oragID}>
                    <Button variant="ghost" className="flex items-center gap-2">

                        <BuildingIcon className="h-5 w-5 text-gray-500 dark:text-gray-400" />

                        <span className="text-gray-700 dark:text-gray-300">
                            {organizationTitle}
                        </span>

                        {hasEnoughOrganizations && (
                            <div className="flex items-center space-x-3">
                                <ChevronDownIcon
                                    className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                            </div>
                        )}
                    </Button>
                </DropdownMenuTrigger>

                {oragID && (
                    <LucideSettings
                        onClick={handleSettingsClick}
                        className="h-4 w-4 text-gray-500 dark:text-gray-400 cursor-pointer" />
                )}
            </div>

            {/* Organizations Options List */}
            {hasEnoughOrganizations && (
                <DropdownMenuContent className="w-56">
                    <ScrollArea className='max-h-[350px]'>
                        {organizations.map((org, index) => (
                            <DropdownMenuItem
                                disabled={org.clusterStatus !== 'DEPLOYED'}
                                key={index}
                                action={() => handleOrganizationChange(org)}>
                                <BuildingIcon
                                    className="h-5 w-5 mr-2 text-gray-500 dark:text-gray-400" />
                                {org?.name}
                            </DropdownMenuItem>
                        ))}
                    </ScrollArea>

                    <DropdownMenuItem
                        className="mt-1 bg-muted font-[500]"
                        action={handleViewAllOrganizations}>
                        View All Organizations
                    </DropdownMenuItem>
                </DropdownMenuContent>
            )}
        </DropdownMenu>
    );
}